import React from 'react';

import Figure from './figure';
import WysiwygContent from './wysiwyg-content';
import HeadingBody from './heading-body';
import { Media } from 'types/media';

export type IntroSimpleProps = {
  title?: string;
  description?: string;
  icon?: Omit<Media, 'id' | 'srcSet'>;
};
const IntroSimple: React.FC<IntroSimpleProps> = ({
  title,
  description,
  icon,
}) => (
  <div className="!gap-y-4 mb-8">
    {icon && <Figure {...icon} className="w-10 pb-4" />}
    {title && (
      <HeadingBody
        {...{
          level: '2',
          tagName: 'h3',
          title,
          className: 'font-semibold',
        }}
      />
    )}
    {description?.length > 0 && (
      <WysiwygContent
        content={description}
        className="mt-8 !text-3xl leading-tight"
      />
    )}
  </div>
);

export default IntroSimple;
